<template>
  <div class="chat-history-status" role="status" aria-live="polite">
    <span v-if="conversation.historyLoading || conversation.syncingHistory" class="history-spinner" :aria-label="$t('tips.loading')"></span>
    <template v-else-if="conversation.historyError">
      <span>{{ $t('chat.historyFailed') }}</span>
      <button type="button" @click="$emit('retry')">{{ $t('chat.retry') }}</button>
    </template>
    <span v-else-if="conversation.hasMoreHistory === false">{{ $t('chat.noHistory') }}</span>
  </div>
</template>

<script>
export default {
  props: { conversation: { type: Object, required: true } },
  emits: ['retry'],
};
</script>

<style scoped>
.chat-history-status { min-height: 36px; box-sizing: border-box; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 6px 12px; color: #969799; font-size: 12px; }
button { border: 0; background: transparent; color: #b85a4a; font: inherit; padding: 8px; cursor: pointer; }
.history-spinner { width: 13px; height: 13px; border: 2px solid #ddd; border-top-color: #aaa; border-radius: 50%; animation: history-spin .8s linear infinite; }
@keyframes history-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .history-spinner { animation: none; } }
</style>
